const APP_STARTED = 'APP_STARTED';
const SET_USER = 'SET_USER';
const REMOVE_USER = 'REMOVE_USER';
const NO_USER = 'NO_USER';
const RESET_VALUES = 'RESET_VALUES';

const appLoading = () => {
	return {
		type: APP_STARTED,
	};
};

const setUser = (userDetails) => {
	return {
		type: SET_USER,
		userDetails,
	};
};

const removeUser = (authKey, history = null) => {
	return {
		type: REMOVE_USER,
		authKey,
		history,
	};
};

const getUser = () => {
	return {
		type: NO_USER,
	};
};

const resetValues = () => {
	return {
		type: RESET_VALUES,
	};
};

export default {
	types: {
		APP_STARTED,
		SET_USER,
		NO_USER,
		REMOVE_USER,
		RESET_VALUES,
	},
	creators: {
		appLoading,
		setUser,
		getUser,
		removeUser,
		resetValues,
	},
};
